export default __webpack_public_path__ + "static/cover-73b7741524eb35157552e7bec5a5d49c.jpg";